import { getCardRates, hasPositiveRate } from '@shared-core/features/backend'
import { useCardTemplates } from '@shared-core/hooks/use-card-templates'
import { useCards } from '@shared-core/hooks/use-cards'

export function useCardRates(requestedCardId?: string) {
  const templates = useCardTemplates()
  const cards = useCards()

  const card = cards?.find((item) =>
    requestedCardId ? item.id === requestedCardId : item.status === 'active' || item.status === 'frozen',
  )
  const rates = card ? getCardRates(card, templates) : undefined

  return {
    cardId: card?.id,
    topupRate: hasPositiveRate(rates?.topupRate) ? rates?.topupRate : undefined,
    withdrawRate: hasPositiveRate(rates?.withdrawRate) ? rates?.withdrawRate : undefined,
  }
}
